


import React from "react";
import ViewPrimaryOrderOms from "./ViewPrimaryOrderOms";
import ViewPrimaryOrderOMSTest from "./ViewPrimaryOrderOMSTest";

const ViewPrimaryOrderOMSContainer = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  
  const viewPrimaryOrderVersion =  ConfigDictionary?.enableManagePrimaryOrderOmsV2 ?? false;

  return viewPrimaryOrderVersion ? (
    <ViewPrimaryOrderOMSTest />
  ) : (
    <ViewPrimaryOrderOms />
  );
};

export default ViewPrimaryOrderOMSContainer;
